import FeatureWayfinder from './feature/FeatureWayfinder';
import VideoWayfinder from './video/VideoWayfinder';
import WayfinderDualCta from './dual_cta/WayfinderDualCta';
import ImageBackground from './image_background/ImageBackground';
import WayfinderFullFeature from './full_feature/WayfinderFullFeature';
import WayfinderLocator from './locator/WayfinderLocator';
import WayfinderComfortChart from './comfort_chart/WayfinderComfortChart';

export default async function Wayfinder({ block, position }) {
  const {
    locale,
    background_color_picker: background_color,
    block_color_picker: block_color,
    modular_blocks,
    tags,
    updated_at,
    uid: entry_uid
  } = block?.wayfinder?.reference?.[0] ?? {};

  if (!modular_blocks || modular_blocks.length === 0) {
    console.warn('[Wayfinder] No modular blocks found.');
    return null;
  }

  switch (Object.keys(modular_blocks[0])[0]) {
    case 'comfort_chart':
      // issues with the below component due to data not been updated when migrated
      return (
        <WayfinderComfortChart
          block={modular_blocks[0]}
          backgroundColor={background_color}
          position={position}
        />
      );
    case 'dual_cta':
      return (
        <WayfinderDualCta
          block={modular_blocks[0]}
          background_color={background_color}
          position={position}
        />
      );
    case 'feature':
      return (
        <FeatureWayfinder
          block={modular_blocks[0]}
          locale={locale}
          background_color={background_color}
          block_color={block_color}
          tags={tags}
          updated_at={updated_at}
          position={position}
        />
      );
    case 'full_feature':
      return (
        <WayfinderFullFeature
          block={modular_blocks[0]}
          backgroundColor={background_color}
          position={position}
        />
      );
    case 'image_background':
      return (
        <ImageBackground
          block={modular_blocks[0]}
          backgroundColor={background_color}
          position={position}
          entry_uid={entry_uid}
        />
      );
    case 'locator':
      return (
        <WayfinderLocator
          block={modular_blocks[0]}
          backgroundColor={background_color}
          position={position}
        />
      );
    case 'video':
      return (
        <VideoWayfinder
          block={modular_blocks[0]}
          locale={locale}
          background_color={background_color}
          block_color={block_color}
          tags={tags}
          updated_at={updated_at}
          entry_uid={entry_uid}
          position={position}
        />
      );

    default:
      return <div>Wayfinder - {Object.keys(modular_blocks[0])[0]}</div>;
  }
}
